import React from 'react';
import {
    Activity,
    AlertCircle,
    ArrowUpDown,
    CheckSquare,
    Layers,
    Pill,
    Settings2,
    AlertTriangle,
    ArrowDownToLine,
    ArrowDownWideNarrow,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUpRight,
    ArrowUpFromLine,
    Award,
    BadgeCheck,
    BadgeDollarSign,
    BadgePercent,
    Ban,
    Barcode,
    BarChart2,
    BarChart3,
    Bell,
    BellOff,
    BellRing,
    Box,
    Bot,
    BookOpen,
    Boxes,
    Building2,
    Briefcase,
    Calendar,
    CalendarClock,
    CalendarDays,
    CalendarRange,
    ChartNoAxesCombined,
    ChevronsLeft,
    ChevronsRight,
    Check,
    CheckCircle,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsUpDown,
    Circle,
    CircleAlert,
    CircleDollarSign,
    ClipboardCheck,
    ClipboardList,
    Clock,
    Clock3,
    CloudUpload,
    Code,
    ContactRound,
    Copy,
    CreditCard,
    Database,
    DatabaseBackup,
    DatabaseZap,
    Delete,
    DollarSign,
    Download,
    ExternalLink,
    FileArchive,
    FileCheck,
    FileCheck2,
    FileDown,
    FileJson,
    FileOutput,
    FilePlus,
    FileSearch,
    FileSpreadsheet,
    FileText,
    FileWarning,
    Files,
    Fingerprint,
    FolderOpen,
    MailWarning,
    PauseCircle,
    GitBranchPlus,
    GitCompare,
    Globe,
    HandCoins,
    Handshake,
    Hash,
    HardDrive,
    HelpCircle,
    History,
    Home,
    House,
    Hourglass,
    ImagePlus,
    Inbox,
    Info,
    KeyRound,
    Landmark,
    LayoutDashboard,
    Layers3,
    LineChart,
    LoaderCircle,
    Lock,
    LogIn,
    LogOut,
    MapPin,
    Menu,
    Mail,
    MessageCircle,
    MessageCircleMore,
    MessageSquare,
    Minus,
    Monitor,
    Moon,
    Eye,
    EyeOff,
    Gem,
    Package,
    PackageCheck,
    PackageMinus,
    PackageSearch,
    PackageX,
    Palette,
    PanelRightOpen,
    Pencil,
    PenLine,
    Percent,
    Phone,
    Play,
    PlayCircle,
    Plus,
    Printer,
    PlugZap,
    Power,
    Receipt,
    ReceiptText,
    RefreshCw,
    RotateCcw,
    Save,
    Scale,
    ScanSearch,
    Search,
    SearchX,
    Send,
    Server,
    Sparkles,
    Settings,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldX,
    ShoppingCart,
    SlidersHorizontal,
    SquarePen,
    Smartphone,
    Sun,
    SunMedium,
    Store,
    Tag,
    Target,
    Timer,
    TimerReset,
    Trash2,
    TrendingDown,
    TrendingUp,
    TriangleAlert,
    Truck,
    Upload,
    UploadCloud,
    User,
    UserCheck,
    UserPlus,
    UserRoundCheck,
    UserRoundPlus,
    Users,
    UsersRound,
    Wallet,
    WalletCards,
    Waves,
    Wifi,
    WifiOff,
    Wrench,
    X,
    XCircle,
    MoonStar,
    Loader2,
    Headphones,
    Zap,
    DoorOpen,
    Stethoscope,
    Warehouse,
} from 'lucide-react';

const iconMap = {
    Activity,
    AlertCircle,
    ArrowUpDown,
    CheckSquare,
    Layers,
    Pill,
    Settings2,
    AlertTriangle,
    ArrowDownToLine,
    ArrowDownWideNarrow,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUpRight,
    ArrowUpFromLine,
    Award,
    BadgeCheck,
    BadgeDollarSign,
    BadgePercent,
    Ban,
    BanknoteArrowUp: BadgeDollarSign,
    Barcode,
    BarChart2,
    BarChart3,
    Bell,
    BellOff,
    BellRing,
    Box,
    Bot,
    BookOpen,
    Boxes,
    Building2,
    Briefcase,
    Calendar,
    CalendarClock,
    CalendarDays,
    CalendarRange,
    ChartNoAxesCombined,
    ChevronsLeft,
    ChevronsRight,
    Check,
    CheckCircle,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsUpDown,
    Circle,
    CircleAlert,
    CircleDollarSign,
    ClipboardCheck,
    ClipboardList,
    Clock,
    Clock3,
    CloudUpload,
    Code,
    ContactRound,
    Copy,
    CreditCard,
    Database,
    DatabaseBackup,
    DatabaseZap,
    Delete,
    DollarSign,
    Download,
    ExternalLink,
    FileArchive,
    FileCheck,
    FileCheck2,
    FileDown,
    FileJson,
    FileOutput,
    FilePlus,
    FileSearch,
    FileSpreadsheet,
    FileText,
    FileWarning,
    Files,
    Fingerprint,
    FolderOpen,
    MailWarning,
    PauseCircle,
    GitBranchPlus,
    GitCompare,
    Globe,
    HandCoins,
    Handshake,
    Hash,
    HardDrive,
    HelpCircle,
    History,
    Home,
    House,
    Hourglass,
    ImagePlus,
    Inbox,
    Info,
    KeyRound,
    Landmark,
    LayoutDashboard,
    Layers3,
    LineChart,
    LoaderCircle,
    Lock,
    LogIn,
    LogOut,
    MapPin,
    Menu,
    Mail,
    MessageCircle,
    MessageCircleMore,
    MessageSquare,
    Minus,
    Monitor,
    Moon,
    Eye,
    EyeOff,
    Gem,
    Package,
    PackageCheck,
    PackageMinus,
    PackageSearch,
    PackageX,
    Palette,
    PanelRightOpen,
    Pencil,
    PenLine,
    Percent,
    Phone,
    Play,
    PlayCircle,
    Plus,
    Printer,
    PlugZap,
    Power,
    Receipt,
    ReceiptText,
    RefreshCw,
    RotateCcw,
    Save,
    Scale,
    ScanSearch,
    Search,
    SearchX,
    Send,
    Server,
    Sparkles,
    Settings,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldX,
    ShoppingCart,
    SlidersHorizontal,
    SquarePen,
    Smartphone,
    Sun,
    SunMedium,
    Store,
    Tag,
    Target,
    Timer,
    TimerReset,
    Trash2,
    TrendingDown,
    TrendingUp,
    TriangleAlert,
    Truck,
    Upload,
    UploadCloud,
    User,
    UserCheck,
    UserPlus,
    UserRoundCheck,
    UserRoundPlus,
    Users,
    UsersRound,
    Wallet,
    WalletCards,
    Waves,
    Wifi,
    WifiOff,
    Wrench,
    X,
    XCircle,
    MoonStar,
    Loader2,
    Headphones,
    HeadphonesIcon: Headphones,
    Zap,
    DoorOpen,
    Stethoscope,
    Warehouse,
};

function AgtIconSvg({ size = 24, color = 'currentColor', strokeWidth = 2, className = '', ...props }) {
    const s = Number(size);
    const sw = Number(strokeWidth);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={s}
            height={s}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth={sw}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            {/* Retângulo com cantos arredondados */}
            <rect x="1.5" y="4" width="21" height="16" rx="3" ry="3" stroke={color} strokeWidth={sw} fill="none" />
            <text
                x="12"
                y="16"
                textAnchor="middle"
                fontSize="10"
                fontWeight="900"
                fontFamily="'Arial Black', Arial, sans-serif"
                fill={color}
                stroke="none"
                letterSpacing="-0.3"
            >
                AGT
            </text>
        </svg>
    );
}

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    if (name === 'AgtIcon') {
        return <AgtIconSvg size={size} color={color} strokeWidth={strokeWidth} className={className} {...props} />;
    }

    const IconComponent = iconMap?.[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;